// inv/src/pages/solutions/early-stage-startup-founders/blocks/FoundersResearchSection.jsx
import { useTranslation } from 'react-i18next';
import CTAHover from '../../../../components/ui/CTAHover';
import { CheckCircle2 } from 'lucide-react';

const FoundersResearchSection = ({ bgColor = 'bg-slate-50' }) => {
  const { t } = useTranslation();

  return (
    <section className={`py-16 sm:py-24 ${bgColor}`}>
      <div className="w-[75%] mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 gap-16 items-center">
        <div className="order-2 lg:order-1">
          <h3 className="text-2xl text-blue-600 font-bold mb-4">
            {t(
              'pageSolutions.EarlyStageFounders.t11',
              'Go beyond basic investor lists'
            )}
          </h3>
          <h2 className="text-3xl sm:text-4xl font-semibold text-stone-900">
            {t(
              'pageSolutions.EarlyStageFounders.t12',
              'Understand each investor’s deal history and thesis'
            )}
          </h2>

          <p className="mt-6 text-base leading-7 text-stone-700">
            {t(
              'pageSolutions.EarlyStageFounders.t13',
              'Crino gives you context on how investors actually deploy capital, so you can tailor your pitch and outreach to what they care about.'
            )}
          </p>

          {/* Modern list */}
          <ul className="mt-6 space-y-4 text-base leading-7 text-stone-700">
            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EarlyStageFounders.t14',
                  'Review recent deals by round, valuation range and co-investors.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EarlyStageFounders.t15',
                  'Identify patterns in the founders, sectors and geographies they back.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EarlyStageFounders.t16',
                  'Prepare data-driven outreach with concrete references to their portfolio.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EarlyStageFounders.t17',
                  'Quickly qualify whether a fund is worth your time before meeting.'
                )}
              </span>
            </li>
          </ul>

          <CTAHover
            className="mt-8"
            text={t(
              'pageSolutions.EarlyStageFounders.t18',
              'Analyse investors in your space'
            )}
            href="find-investors/"
            align="left"
            bgColor="bg-amber-300 text-stone-800"
            textColor="text-stone-800"
            hoverTextColor="text-stone-800"
          />
        </div>

        <div className="order-1 lg:order-2 mb-12 lg:mb-0">
          <img
            className="w-full"
            src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/solutions/crino-real-time-financing-rounds.png"
            alt={t(
              'pageSolutions.EarlyStageFounders.alt2',
              'Investor profile dashboard showing deal history, seed-stage investments and early-stage VC activity'
            )}
          />
        </div>
      </div>
    </section>
  );
};

export default FoundersResearchSection;
